module.exports = __webpack_public_path__ + "img/icon_edit.ea510baa.svg";